// Utilitaires partagés du Studio.

// Jours ISO (1 = lundi … 7 = dimanche) — ordre d'affichage.
export const ISO_DAYS = [1, 2, 3, 4, 5, 6, 7];
export const DAY_KEYS = { 1: "mon", 2: "tue", 3: "wed", 4: "thu", 5: "fri", 6: "sat", 7: "sun" };

// HHMM entier -> "HH:MM"  (2000 -> "20:00", 930 -> "09:30")
export function hhmmToTimeStr(n) {
  const v = Number(n) || 0;
  const h = Math.floor(v / 100);
  const m = v % 100;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

// "HH:MM" -> HHMM entier  ("20:00" -> 2000, "09:30" -> 930)
export function timeStrToHhmm(s) {
  if (!s) return 0;
  const [h, m] = String(s).split(":").map((x) => parseInt(x, 10) || 0);
  return h * 100 + m;
}

// Métadonnées d'un statut de radio (clé i18n + classes de badge).
export function statusMeta(status) {
  switch ((status || "").toLowerCase()) {
    case "active":
    case "online":
      return { key: "active", cls: "bg-green-50 text-green-700" };
    case "provisioning":
      return { key: "provisioning", cls: "bg-amber-50 text-amber-700" };
    case "error":
    case "failed":
      return { key: "error", cls: "bg-red-50 text-red-700" };
    default:
      return { key: "unknown", cls: "bg-gray-100 text-gray-500" };
  }
}
